import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthQrcodeService } from 'src/app/shared/services';

@Component({
  selector: 'app-block-user',
  templateUrl: './block-user.component.html',
  styleUrls: ['./block-user.component.scss']
})
export class BlockUserComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authQrcodeService: AuthQrcodeService
  ) { }

  reason = '';
  ngOnInit() {
    const body = {};
    this.authQrcodeService.login(body).subscribe(res => {
      this.reason = res.data.reason;
    });
  }

  back() {
    this.router.navigate(['/auth/login']);
  }
}
